import { render, staticRenderFns } from "./contractSign.vue?vue&type=template&id=0fd4d8e3&scoped=true&"
import script from "./contractSign.js?vue&type=script&lang=js&"
export * from "./contractSign.js?vue&type=script&lang=js&"
import style0 from "./contractSign.vue?vue&type=style&index=0&id=0fd4d8e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4d8e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd4d8e3')) {
      api.createRecord('0fd4d8e3', component.options)
    } else {
      api.reload('0fd4d8e3', component.options)
    }
    module.hot.accept("./contractSign.vue?vue&type=template&id=0fd4d8e3&scoped=true&", function () {
      api.rerender('0fd4d8e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderDialog/contractSign.vue"
export default component.exports